export default __webpack_public_path__ + "static/media/404.b585263a.gif";